module.exports = __webpack_public_path__ + "static/media/lock.9f3b9ecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/lock.svg
// module id = 592
// module chunks = 0